module.exports = __webpack_public_path__ + "static/blog-fallback-ec84f77decd464f6ece179d2aa46a6de.jpg";